// slider-button-control.ts
import { FlexiButton } from "appworks/graphics/elements/flexi-button";
import { ButtonControl } from "appworks/ui/controls/standard/button/button-control";
import { slotModel } from "slotworks/model/slot-model";

export class AgsBetButtonControl extends ButtonControl {
    protected onModelUpdateCallback: Function;
    protected isIncrement: boolean;

    /**
     * Constructs a new `AgsBetButtonControl` object.
     * @param button - A `FlexiButton` object representing the button element.
     * @param isIncrement - A boolean value that specifies whether the button should increment or decrement the bet amount.
     */
    constructor(button: FlexiButton, isIncrement: boolean) {
        super(button);
        this.isIncrement = isIncrement;
        this.onModelUpdateCallback = () => this.onModelUpdate();
        slotModel.onUpdate.add(this.onModelUpdateCallback);

    }

    /**
     * Destroys the `AgsBetButtonControl` object and cleans up any resources associated with it.
     */
    public override destroy(): void {
        super.destroy();
        this.button.setVisible(false);
        slotModel.onUpdate.remove(this.onModelUpdateCallback);
    }

     /**
     * Called when the button control is clicked.
     * Increments or decrements the bet amount based on the `isIncrement` property of the object.
     * Saves the updated bet amount to the slot model.
     */
    protected override onClick(): void {
        const { creditsPerLine } = slotModel.read().bet;
        const currentIndex = creditsPerLine.values.findIndex(element => element === creditsPerLine.currentValue);

        let nextValue;
        if (this.isIncrement) {
            nextValue = creditsPerLine.values[currentIndex + 1] ?? creditsPerLine.values[creditsPerLine.values.length - 1];
        } 
        else {
            nextValue = creditsPerLine.values[currentIndex - 1] ?? creditsPerLine.values[0];
        }

        creditsPerLine.currentValue = nextValue;
        creditsPerLine.lastSelectedValue = nextValue;

        slotModel.write({ bet: { creditsPerLine } });
    }

    protected onModelUpdate(): void {
        this.setEnabled(this.enabled);
    }
}
